import { NotesManagerContent } from "@/features/notes-manager";
import { GeneralNotesTabsContent } from "@/pages/ContactsPage/Components/GeneralNotesTabsContent";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { useNotesManager } from "../model";

export const NotesTab = () => {
  const notesManager = useNotesManager();

  return (
    <GeneralNotesTabsContent
      noteManager={
        <NotesManagerContent
          notesManager={notesManager}
          noteType={DEFAULT_NOTE_TYPES.DEFAULT_NOTE}
          contactsPage
        />
      }
    />
  );
};
